import React, {Component} from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "@common/components/modal";
import { Button } from '@common/components/Button';
import { FormControl } from '@common/components/form-control';
import PropTypes from "prop-types";
import { I18n } from 'react-redux-i18n';

export class AmbryKeyDialog extends Component {
    constructor(props) {
        super(props);

        this.props.onLoad();
    }

    handleChange = (type, e) => {
        e.preventDefault();
        const value = e.target.value;
        this.props.onDataChange(type, value);
    };

    render() {
        return (
            <Modal style={{top: '25%'}}
                   bsClass="bootstrap modal"
                   show={this.props.show}
                   onHide={this.props.onHide}
                   animation={false} backdrop="static">
                <ModalHeader closeButton onHide={this.props.onHide}>
                    <ModalTitle id="ambry-keys-header" style={{color: '#008DCE', fontWeight: 'normal'}}>{I18n.t('Ambry Ordering Keys')}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="row" style={{marginTop: '20px'}}>
                        <div id="lbl-client-id" className="col-sm-3" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('Client ID')}</div>
                        <div className="col-sm-8">
                            <FormControl
                                id="tx-client-id"
                                className="form-control"
                                type="text"
                                value={this.props.clientId ? this.props.clientId : ''}
                                onChange={this.handleChange.bind(this, 'clientId')}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: '5px'}}>
                        <div id="lbl-client-sec-key" className="col-sm-3" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('Client Secret Key')}</div>
                        <div className="col-sm-8">
                            <FormControl
                                id="tx-client-sec-key"
                                className="form-control"
                                type="text"
                                value={this.props.clientSecret ? this.props.clientSecret : ''}
                                onChange={this.handleChange.bind(this, 'clientSecret')}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: '5px'}}>
                        <div id="lbl-client-url" className="col-sm-3" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('URL')}</div>
                        <div className="col-sm-8">
                            <FormControl
                                id="tx-client-url"
                                className="form-control"
                                type="text"
                                value={this.props.hostAddress ? this.props.hostAddress : ''}
                                onChange={this.handleChange.bind(this, 'hostAddress')}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: '5px'}}>
                        <div id="lbl-client-grant-type" className="col-sm-3" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('Grant Type')}</div>
                        <div className="col-sm-8">
                            <FormControl
                                id="tx-client-grant-type"
                                className="form-control"
                                type="text"
                                value={this.props.grantType ? this.props.grantType : ''}
                                onChange={this.handleChange.bind(this, 'grantType')}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button id="btn-cancel" key="no" style={{width: "100px"}} onClick={this.props.onHide}>{I18n.t('Cancel')}</Button>
                    <Button id="btn-save" key="ok" type="submit" bsStyle="primary" style={{width: "100px"}} onClick={this.props.onSave}>{I18n.t('Save')}</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

AmbryKeyDialog.propTypes = {
    show: PropTypes.bool.isRequired,
    error: PropTypes.string,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onDataChange: PropTypes.func.isRequired,
    onLoad: PropTypes.func.isRequired,
    clientId: PropTypes.string,
    clientSecret: PropTypes.string,
    hostAddress: PropTypes.string,
    grantType: PropTypes.string,
};